import { List, ListItem, styled } from '@mui/material';
import { LABEL_MAP } from '../ContactChangeAlert/constants';
import { ContactChangeAction, type ContactChangeDetail } from './types';

const StyledList = styled(List)(({ theme }) => ({
  listStyleType: 'disc',
  paddingTop: 0,
  paddingLeft: theme.spacing(6),
  color: 'text.secondary',
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'list-item',
  padding: 0,
  ...theme.typography.body2,
}));

const isEmptyValue = (value: string) => value === 'undefined' || value === '';

export const ContactChangedFieldsList = ({
  contact,
}: {
  contact: ContactChangeDetail;
}) => {
  if (contact.action === ContactChangeAction.None) {
    return null;
  }

  // Added and deleted contacts will only have one bullet
  if (contact.action === ContactChangeAction.Added) {
    return (
      <StyledList>
        <StyledListItem>Added</StyledListItem>
      </StyledList>
    );
  }

  if (contact.action === ContactChangeAction.Deleted) {
    return (
      <StyledList>
        <StyledListItem>Removed</StyledListItem>
      </StyledList>
    );
  }

  // All other contacts will have a bullet for each field that has changed
  return (
    <StyledList>
      {contact.fields.map((field) => (
        <StyledListItem key={field.propName}>
          {LABEL_MAP[field.propName] === 'Avatar' ? (
            'Avatar Updated'
          ) : (
            <>
              {LABEL_MAP[field.propName]}:{' '}
              {isEmptyValue(field.currentValue) ? (
                '(empty)'
              ) : (
                <span style={{ textDecoration: 'line-through' }}>
                  {field.currentValue}
                </span>
              )}{' '}
              &rarr; {isEmptyValue(field.newValue) ? '(empty)' : field.newValue}
            </>
          )}
        </StyledListItem>
      ))}
    </StyledList>
  );
};
